import * as React from 'react';
import { styled } from 'styled-components';

import { Button, ButtonLoaderIcon, Icon, Modal, tk } from '@sunwebgroup/ui-components';

import { useFilters, useResults } from '@/scopes/search/search/domain/hooks';
import { useIntl } from '@/intl';

import { SelectedFiltersChips } from './SelectedFiltersChips';
import { Filters } from './Filters';

const FiltersButton = styled(Button)`
  display: flex;
  position: fixed;
  bottom: 0;
  margin: ${tk('spacing_md')} ${tk('spacing_md')} ${tk('spacing_xl')};
  z-index: 1; // To ensure the filter button is always on top of the accommodation slider

  @media ${tk('mq_desktop_lg')} {
    display: none;
  }
`;

const Content = styled.div`
  width: 100%;
  padding: ${tk('spacing_md')};

  @media ${tk('mq_tablet')} {
    padding: ${tk('spacing_lg')};
  }
`;

export function FiltersModal() {
  const intl = useIntl();
  const { isFetching } = useResults();
  const { resetOptionalFilters } = useFilters();

  const [showModal, setShowModal] = React.useState(false);

  const onClose = () => setShowModal(false);
  const openModal = () => setShowModal(true);

  return (
    <>
      <FiltersButton $hierarchy="primary" $withoutColor onClick={openModal}>
        <Icon glyph="IconFilter" />
        {intl.formatMessage({ id: 'search_open_filters' })}
      </FiltersButton>
      <Modal.Root open={showModal} onClose={onClose}>
        <Modal.Content $size="md">
          <Modal.Header>
            <Modal.HeaderTitle text={intl.formatMessage({ id: 'search_open_filters' })} />
            <Modal.HeaderCloseButton />
          </Modal.Header>
          <Modal.Body>
            <Content>
              <SelectedFiltersChips />
              <Filters />
            </Content>
          </Modal.Body>
          <Modal.Footer>
            <Button
              $hierarchy="tertiary"
              $withoutColor
              onClick={() => {
                resetOptionalFilters();
                onClose();
              }}
            >
              {intl.formatMessage({ id: 'search_reset_filters' })}
            </Button>
            <Button $hierarchy="primary" disabled={isFetching} onClick={onClose}>
              {isFetching && <ButtonLoaderIcon />}
              {intl.formatMessage({ id: 'search_apply_filters' })}
            </Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
